<div>
  <div class="loader-bg col-12" *ngIf="showLoader">
    <span class="loader"><span class="loader-inner"></span></span>
  </div>

  <div class="modal-header col-12">
    <img title="Close Modal" (click)="closeModal()" width="17" height="17" src="assets/images/cross-dark-grey.svg">
  </div>
  <div class="modal-body">
    <div *ngIf="!showSuccess">
    <h2 class="modal-title col-12">Forgot Your Password?</h2>

      <p class="error-message" *ngIf="showErrorMsg">No user found with this email.</p>

      <label class="forgot-password-text mt-3"> Enter the email address associate with your account.We'll send you an email with instruction to reset your password.</label>

    <form class="form-bg col-12" [formGroup]="forgotPwdForm" style="margin-top: 15px;">
      <div class="form-group">
        <label for="email">Your Email</label>
        <input type="email" name="email" class="form-control" #email required id="email" formControlName="email" autocomplete="off">
        <small *ngIf="forgotPwdForm.get('email').invalid && (forgotPwdForm.get('email').dirty || forgotPwdForm.get('email').touched)" class="error-text-color">
          <span *ngIf="forgotPwdForm.controls['email'].errors.required && forgotPwdForm.controls['email'].errors.email">
            Email is required.
          </span>
          <span *ngIf="forgotPwdForm.controls['email'].errors.pattern && !forgotPwdForm.controls['email'].errors.required">
            Invalid email address.
          </span>
        </small>
      </div>


      <div class="btn-bg mt-5">
        <button type="submit" class="btn-green col-10" [disabled]="forgotPwdForm.invalid" (click)="forgotPwdFun()" [ngClass]="{'btn-green-disabled' : forgotPwdForm.invalid}">Reset Password</button>
      </div>
    </form>

      </div>

      <div *ngIf="showSuccess">
        <h2 class="modal-title col-11" style="margin: 0 auto;">Success!</h2>
        <label class="forgot-password-text mt-3">Please check your email. We've sent you a link to reset your password.</label>

        <div class="btn-bg" style="margin-top: 50% !important; margin-bottom: 5%;">
          <button type="submit" class="btn-green col-10"  (click)="closeModal()">Done</button>
        </div>
      </div>

  </div>
</div>



// WEBPACK FOOTER //
// ./src/app/modules/user/auth/forgot-pwd/forgot-pwd.component.html